/*===================================================================
=       TeamListPage                           =
====================================================================*/
import TeamList from "../../../features/team/components/TeamList";
import PageLayout from '../../../components/organismes/PageLayout/PageLayout';
import styles from "./teamListPage.module.scss";

const TeamListPage = () => {
  return (
    <PageLayout 
      title="Équipes"
 maxWidth="1200px"
      className={styles["team-list-page"]}
    >
      <div className={styles["header"]}>
        <div className={styles["btn"]}>
          <TeamList.CreateNewTeamBtn />
        </div>
        <div className={styles["btn"]}>
          <TeamList.ImportBtn />
        </div>
      </div>
      <TeamList.Filter />
      <TeamList.List />
    </PageLayout>
  );
};

export default TeamListPage;
